export default "__VITE_ASSET__CX1$Xu1I__"